<template lang="pug">
b-modal#exchangeCurrencyTicketDetail(
  ref="exchangeCurrencyTicketDetail"
  :title='$t("ui.ticket_detail")'
  centered
  no-fade
  no-close-on-backdrop
  ok-only
  :busy="loading"
  @show="reset"
  @shown="shown"
)
  template(v-if="ticketDetail")
    .clusterize-scroll.table-responsive
      table.table.table-sm.table-bordered.table-striped.table-hover
        thead.thead-light
          tr
            th(width="35%")
              span  {{ $t("ui.exchange_currency") }}
            th(width="65%")
              span &nbsp;
        tbody.clusterize-content
          tr
            td
              span {{ $t("ui.id") }}
            td
              span {{ ticketDetail.id }}
          tr
            td
              span {{ $t("ui.member") }}
            td
              span {{ ticketDetail.member_id }}
          tr
            td
              span {{ $t("ui.amount") }}
            td
              span.font-weight-bold(:class="$helpers.fontClassName(ticketDetail.amount)") {{ $n(ticketDetail.amount, 'currency') }}
          //- tr
          //-   td
          //-     span {{ $t("ui.exchange_currency") }}
          //-   td
          //-     span(:title="ticketDetail.exchange_currency") {{ ticketDetail.exchange_currency }}
          tr
            td
              span {{ $t("ui.base_rate") }} ({{ getCurrencyCode }})
            td
              span.font-weight-bold(:title="$n(ticketDetail.base_rate, 'currency')" :class="$helpers.fontClassName(ticketDetail.base_rate)") {{ $n(ticketDetail.base_rate, 'currency') }}
          tr
            td
              span {{ $t("ui.exchange_rate") }} ({{ ticketDetail.exchange_currency }})
            td
              span.font-weight-bold(:title="$n(ticketDetail.exchange_rate, 'currency')" :class="$helpers.fontClassName(ticketDetail.exchange_rate)") {{ $n(ticketDetail.exchange_rate, 'currency') }}
          tr
            td
              span {{ $t("ui.exchanged_amount") }}
            td
              span.font-weight-bold(:title="ticketDetail.exchanged_amount" :class="$helpers.fontClassName(ticketDetail.exchanged_amount)") {{ ticketDetail.exchanged_amount }}

    div(slot="modal-footer")
      SubmitButton.float-right(icon="far fa-times-circle" :text="$t('ui.close')" @click="closeModal()" size="sm" variant="primary").mr-1
</template>

<script>
import { required, minLength, maxLength, url } from "vuelidate/lib/validators";
import config from "@/config";
import errorTags from "@/errorTags";
import SubmitButton from "@/library/SubmitButton";
import DebounceInput from "@/library/DebounceInput";

export default {
  components: {
    SubmitButton,
    DebounceInput
  },
  props: {
    ticketId:{
      type: Number,
      default: 0
    }
  },
  data() {
    return {
      loading: false,
      ticketDetail: null,
      feedback: {
        success: true,
        status: ""
      },
      remark: ""
    };
  },
  computed: {
    getCurrencyCode() {
      return this.$store.getters.currencyCode;
    }
  },
  mounted: function() {
  },
  methods: {
    reset: function() {
      this.feedback.success = true;
      this.feedback.status = "";
    },
    shown: function() {
      this.getTicketDetail();
    },
    getTicketDetail: function() {
      let url = config.ticketDetailUrl();

      var json = {
        action_by: this.$store.getters.loginId,
        auth_token: this.$store.getters.sessionToken,
        ticket_id: this.ticketId,
      };

      this.loading = true;
      this.$http.post(url, json).then(
        function(response) {
          this.loading = false;
          // Success
          try {
            if (response) {
              this.feedback.success = typeof response.data.status == "string" ? response.data.status == "1" : response.data.status == 1;

              this.feedback.status = response.data.statusdesc;
              if (this.feedback.success == true) {
                this.ticketDetail = (response.data.dt.length > 0) ? response.data.dt[0] : null;
              } else {
                if (!this.$helpers.handleFeedback(this.feedback.status)) this.$helpers.showDialog(this.$t("ui.alert"), this.$t("error." + this.feedback.status), "error");
              }
            }
          } catch (error) {
            this.feedback.success = false;
            this.feedback.status = errorTags.request.failed;
            this.$helpers.showDialog(this.$t("ui.alert"), this.$t("error." + this.feedback.status), "error");
          }
        },
        function(response) {
          this.loading = false;
          // Error
          this.feedback.success = false;
          this.feedback.status = errorTags.request.failed;
          this.$helpers.showDialog(this.$t("ui.alert"), this.$t("error." + this.feedback.status), "error");
        }
      );
    },
    closeModal: function() {
      this.$refs.exchangeCurrencyTicketDetail.hide();
    },
  }
};
</script>
